import React from 'react';

import { style, theme } from 'constants';
import { View, isWeb, TabNavigator, AppHeader } from 'core';
import * as actions from 'actions';

import { lang } from 'lang';
import Auth from '../login/auth';
import Verify from '../login/verfiy';
import { getCountryTeleCode } from 'utils';

const styles = style({
  logo: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center'
  },
  login_btn: {
    width: 300,
    marginBottom: isWeb ? 280 : 50
  }
});

class Login extends React.Component {
  state = {
    value: 1,
    account: '',
    country_code: 'SA',
    use_phone: true
  };

  async componentDidMount() {
    const { country_code } = await getCountryTeleCode();
    this.setState({ country_code });
  }

  _setAccount = data => {
    this.setState(data);
  };

  render() {
    const { provide_status, verify_status } = this.props;
    const { account, use_phone, value, country_code } = this.state;
    return (
      <View style={{ maxWidth: 600, height: 500 }}>
        <AppHeader title={lang.NEW_ACCOUNT} close />

        <TabNavigator value={this.state.value} initialValue={1}>
          <View />
          <Auth
            is_add_account={true}
            status={provide_status}
            action={actions.sendUserAddAccount}
            use_phone={use_phone}
            account={account}
            country_code={country_code}
            index={value}
            back={() => this.setState({ value: 0 })}
            onSuccess={() => this.setState({ value: 2 })}
            setAccount={this._setAccount}
            setMethod={() => this.setState({ use_phone: !use_phone, account: '' })}
          />
          <Verify
            is_add_account={true}
            action={actions.sendUserVerifyAddAccount}
            account={account}
            country_code={country_code}
            use_phone={use_phone}
            back={() => this.setState({ value: 1 })}
            index={value}
            status={verify_status}
            onSuccess={actions.clickCloseModal}
          />
        </TabNavigator>
      </View>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/modals/add_account.js